export class Stack implements IStack<any> {
  private storage: any[] = [];

  constructor(private capacity: number = Infinity) { }

  push(item: any): void {
    if (this.size() === this.capacity) {
      throw Error('Stack has reached max capacity, you cannot add more items');
    }
    this.storage.push(item);
  }

  pop(): any | undefined {
    return this.storage.pop();
  }

  peek(): any | undefined {
    return this.storage[this.size() - 1];
  }

  size(): number {
    return this.storage.length;
  }
}

interface IStack<T> {
  push(item: T): void;
  pop(): T | undefined;
  peek(): T | undefined;
  size(): number;
}
